import { c as _c } from "react/compiler-runtime";
import { USER_PAGE_ACTIVITY_TAB } from "../UserPageActivityWrapper";
import UserPageActivityTab from "./UserPageActivityTab";
export default function UserPageActivityTabs(t0) {
  const $ = _c(4);
  const {
    activeTab,
    setActiveTab
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Object.values(USER_PAGE_ACTIVITY_TAB);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== activeTab || $[2] !== setActiveTab) {
    t2 = <div className="tw-inline-flex tw-rounded-lg tw-overflow-hidden">{t1.map(tab => <UserPageActivityTab key={tab} tab={tab} activeTab={activeTab} setActiveTab={setActiveTab} />)}</div>;
    $[1] = activeTab;
    $[2] = setActiveTab;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}